/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC, SVGProps } from 'react';

const WabaQualityRatingMedium: FC<
  SVGProps<SVGSVGElement> & { size?: number }
> = ({ size = '24px', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      {...props}
    >
      <mask
        id="a"
        width={16}
        height={16}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        css={css`
          mask-type: alpha;
        `}
      >
        <path
          fill="#C21313"
          d="M11.66 0c.664 0 1.2.544 1.2 1.219V11.78c0 .675-.536 1.219-1.2 1.219-.664 0-1.2-.544-1.2-1.219V1.22c0-.675.536-1.219 1.2-1.219Zm-9.6 8.125c.664 0 1.2.544 1.2 1.219v2.437c0 .675-.536 1.219-1.2 1.219-.664 0-1.2-.544-1.2-1.219V9.344c0-.675.536-1.219 1.2-1.219Zm4.8-4.063c.664 0 1.2.545 1.2 1.22v6.5c0 .674-.536 1.218-1.2 1.218-.664 0-1.2-.544-1.2-1.219v-6.5c0-.674.536-1.218 1.2-1.218Z"
        />
      </mask>
      <g fill="#E7951C" mask="url(#a)">
        <path d="M0 0h9v13H0z" />
        <path fillOpacity={0.32} d="M0 0h13v13H0z" />
      </g>
    </svg>
  );
};

export default WabaQualityRatingMedium;
